import { render, staticRenderFns } from "./DescricaoPadrao.vue?vue&type=template&id=23980166"
import script from "./DescricaoPadrao.vue?vue&type=script&lang=js"
export * from "./DescricaoPadrao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports